import { v4 as generateUniqueId } from "uuid";

export const createCommonHeaders = (window) => ({
    trackingID: generateUniqueId(),
    channelID: "web",
    deviceType: window.navigator.userAgent,
});
